import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo
} from 'react';

const AuthFlowContext = createContext(null);

const STORAGE_KEY = 'authFlowContextData';

function loadFromStorage() {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function AuthFlowProvider({ children }) {
  const [authFlowData, setAuthFlowData] = useState(loadFromStorage);

  const setAuthFlowContextData = useCallback(updates => {
    setAuthFlowData(prev => {
      const next = { ...prev, ...updates };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const clearAuthFlowContextData = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setAuthFlowData({});
  }, []);

  const value = useMemo(
    () => ({
      policyNumber: authFlowData.policyNumber,
      tempCode: authFlowData.tempCode,
      setAuthFlowContextData,
      clearAuthFlowContextData
    }),
    [
      authFlowData.policyNumber,
      authFlowData.tempCode,
      setAuthFlowContextData,
      clearAuthFlowContextData
    ]
  );

  return (
    <AuthFlowContext.Provider value={value}>
      {children}
    </AuthFlowContext.Provider>
  );
}

export function useAuthFlowContext() {
  return useContext(AuthFlowContext);
}
